import { cn } from "@/lib/utils";

export default function Globe({ className }: { className?: string }) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='currentColor'
            className={cn("size-6", className)}
        >
            <path
                d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
                stroke='white'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4 12H20.0001M12 20.0001C14.209 20.0001 16.0001 16.4184 16.0001 12C16.0001 7.58174 14.209 4 12 4C9.79112 4 8.00002 7.58174 8.00002 12C8.00002 16.4184 9.79112 20.0001 12 20.0001Z'
                stroke='white'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
